import React, { useState } from 'react';
import { Globe, X } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import axios from 'axios';

const API_BASE = "https://clankless-inflatedly-danae.ngrok-free.dev";

const Header = () => {
  const { lang, setLang } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  
const handleCancel = async () => {
  const userId = localStorage.getItem('user_id');
  if (!userId) {
    console.error("No user_id found");
    return;
  }
  setIsLoading(true);
  try {
    const response = await axios.post(
      `${API_BASE}/api/cancel-kyc`,
      { user_id: userId },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': process.env.REACT_APP_API_KEY
        }
      }
    );
    console.log("API response:", response.data);
    if (response.data) {
      window.open('https://my.fenefx.com/dashboard/kyc', '_blank');
      localStorage.removeItem('session_id');
      localStorage.removeItem('user_id');
      window.location.reload();
    }
  } catch (error) {
    console.error("Error canceling KYC:", error);
  } finally {
    setIsLoading(false);
  }
}
  
  return (
    <div className="fixed top-4 right-4 flex gap-3 z-50 animate-slide-down">
      {/* دکمه انصراف */}
      <button
        onClick={handleCancel}
        disabled={isLoading}
        title={lang === 'fa' ? 'انصراف' : 'Cancel'}
        className="px-4 py-2 rounded-xl bg-secondary-black border-2 border-red-500/30 hover:border-red-500 hover:bg-red-500/10 text-red-500 transition-all duration-300 flex items-center justify-center gap-2 transform hover:scale-105 active:scale-95 shadow-lg shadow-red-500/20 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isLoading ? (
          <div className="w-5 h-5 border-2 border-red-500 border-t-transparent rounded-full animate-spin"></div>
        ) : (
          <>
            <X size={18} />
            <span className="text-sm font-bold">
              {lang === 'fa' ? 'انصراف' : 'Cancel'}
            </span>
          </>
        )}
      </button>
      
      {/* دکمه تغییر زبان */}
      <button
        onClick={() => setLang(lang === 'en' ? 'fa' : 'en')}
        title="Toggle Language"
        className="w-12 h-12 rounded-xl bg-secondary-black border-2 border-accent-green/30 hover:border-accent-green hover:bg-accent-green/10 text-accent-green transition-all duration-300 flex items-center justify-center transform hover:scale-110 hover:rotate-6 active:scale-95 shadow-lg shadow-accent-green/20"
      >
        <Globe size={20} />
      </button>
      
      {/* نمایش زبان فعلی */}
      <div className="px-4 py-2 rounded-xl bg-secondary-black border-2 border-accent-golden/30 text-accent-golden font-bold uppercase tracking-wider text-sm flex items-center gap-2 shadow-lg shadow-accent-golden/20">
        <span className="w-2 h-2 rounded-full bg-accent-golden animate-pulse"></span>
        {lang.toUpperCase()}
      </div>
    </div>
  );
};

export default Header;